function setupAccordions() {
	var selector = ".container-accordion";
	var accordions = document.querySelectorAll(selector);

	accordions.forEach(function (accordion, index) {
		try {
			var accordion_nav = accordion.querySelector(".container-accordion__nav");
			var items = accordion.querySelectorAll(".item-accordion");

			items.forEach(function (item, index) {
				var item_id = item.id;

				var item_label = item.getAttribute("aria-label");
				if (!item_label) {
					throw "Missing accordion label: " + item.id + " (" + accordion.id + ")";
				}

				var button = item.querySelector(".item-accordion__trigger");
				button.setAttribute("aria-expanded", false);
				button.setAttribute("aria-controls", item_id + "__content");

				var nav_item = document.createElement("li");
				nav_item.setAttribute("role", "presentation");

				var nav_link = document.createElement("a");
				nav_link.setAttribute("href", "#" + item.id);
				nav_link.setAttribute("role", "tab");
				nav_link.setAttribute("id", accordion.id + "-tab-" + index);
				nav_link.setAttribute("aria-controls", item.id);
				nav_link.setAttribute("class", "item-accordion__trigger item-accordion__trigger--tab | js-tabs-trigger");
				nav_link.textContent = item_label;

				nav_item.append(nav_link);
				accordion_nav.append(nav_item);
			});

			new AccordionTabs(accordion);
		} catch (error) {
			console.error(error);
		}
	});
}

if (CSS.supports("display: flex")) {
	setupAccordions();
}
